<template>
    <module-card :nextDisabled="nextDisabled">
        <v-text-field outlined label="What’s the name you go by?" type="text" v-model="name" @input="name = upperFirst(name)"></v-text-field>
    </module-card>
</template>

<script>
    import { sync } from 'vuex-pathify';
    import { upperFirst } from 'lodash';

    export default {
        computed: {
            name: sync('name')
        },
        methods: {
            upperFirst: upperFirst,
            nextDisabled() {
                return !this.name;
            }
        }
    };
</script>
